import { render, staticRenderFns } from "./reg-pay.vue?vue&type=template&id=09423618"
import script from "./reg-pay.vue?vue&type=script&lang=js"
export * from "./reg-pay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports